import {DialogTitle, Grid, IconButton} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import CloseIcon from "@mui/icons-material/Close";
import {useProject, useProjectId} from "../ProjectName";
import {PopperZIndexProvider} from "../../../../misc/scroller/PopperZIndexProvider";
import {TableSelectionContext} from "../../../../misc/scroller/Table";
import {useContext, useMemo, useState} from "react";
import {openingsTableName} from "./Openings";
import {ChangesetItem} from "../../../../api/ProjectChangeset";
import { TimelineViewer } from "./timeline/TimelineViewer";
import {OpeningsView} from "./timeline/OpeningsView";
import {projectLabel} from "../../../../api/Projects";

export function OpeningTimeline(props: {
    tab: string;
    onClose(): void;
}) {
    const projectId = useProjectId();
    const baseTableName = openingsTableName(projectId, props.tab);
    const project = useProject();

    const {getFilteredOnce} = useContext(TableSelectionContext);
    const openingIds = useMemo(() => {
        return getFilteredOnce(baseTableName).map(v => v.id);
    }, [baseTableName, getFilteredOnce]);

    const [cursor, setCursor] = useState<ChangesetItem>();

    return (
        <Dialog2 open onClose={props.onClose} fullScreen>
            <DialogTitle>
                <Grid container alignItems="center" spacing={1}>
                    <Grid item xs>
                        {project && projectLabel(project)}: Opening Timeline
                    </Grid>
                    <Grid item>
                        <IconButton onClick={props.onClose}>
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            </DialogTitle>
            <TimelineViewer openings={openingIds} value={cursor} onChange={setCursor} />
            <PopperZIndexProvider value={1400}>
                <OpeningsView
                    project={projectId}
                    tab={props.tab}
                    changeset={cursor?.id}
                    openingIds={openingIds}
                />
            </PopperZIndexProvider>
        </Dialog2>
    );
}
